{
  "feedback": {
    "bad": "Κακό",
    "good": "Καλό",
    "excellent": "Εξαιρετικό",
    "heading": "Σας άρεσε;",
    "placeholder": "Τα σχόλιά σας (προαιρετικά)",
    "button": "Αποστολή σχολίων"
  },
  "tips": "Φιλοδωρήματα",
  "receipts_total": "Σύνολο απόδειξης: {{total}}",
  "error": {
    "general": {
      "title": "Κάτι πήγε στραβά",
      "description": "Συγγνώμη, αλλά παρουσιάστηκε ένα σφάλμα. Παρακαλώ δοκιμάστε να ανανεώσετε τη σελίδα"
    }
  },
  "fee": {
    "title": "Κάλυψη τέλους επεξεργασίας;",
    "description": "Όταν δίνετε φιλοδώρημα με κάρτα, υπάρχουν χρεώσεις προς τον εκδότη της κάρτας. Κάνουμε το καλύτερο δυνατό για να τις κρατήσουμε όσο το δυνατόν χαμηλότερες.",
    "receive": "{{name}} θα λάβει <b>{{amount}}</b>",
    "charge": "Θα χρεωθείτε με <b>{{amount}}</b>"
  },
  "success": {
    "feedback": {
      "description": [
        "Εκτιμούμε πραγματικά τα σχόλιά σας! Σας ευχαριστούμε που αφιερώσατε χρόνο για να μοιραστείτε τις σκέψεις σας μαζί μας.",
        "Σας ευχαριστούμε για τα πολύτιμα σχόλιά σας! Η συμβολή σας μας βοηθά να βελτιωθούμε και να σας εξυπηρετούμε καλύτερα.",
        "Ουάου, σας ευχαριστούμε για τα εντυπωσιακά σχόλιά σας! Είμαστε ευγνώμονες για την ειλικρίνεια και τις προτάσεις σας.",
        "Από όλους εμάς, μια εγκάρδια ευχαριστία για τα σχόλιά σας! Είμαστε αφοσιωμένοι στο να χρησιμοποιήσουμε αυτά τα σχόλια για να κάνουμε θετικές αλλαγές.",
        "Σας ευχαριστούμε που μοιραστήκατε τα σχόλιά σας μαζί μας! Η προοπτική σας είναι ανεκτίμητη για εμάς.",
        "Τα σχόλιά σας σημαίνουν πολλά για εμάς! Σας ευχαριστούμε που μας βοηθάτε να κατανοήσουμε πώς μπορούμε να γίνουμε καλύτεροι.",
        "Σας ευχαριστούμε πάρα πολύ για τα σχόλιά σας! Εκτιμούμε τη συμβολή σας στο να κάνουμε την υπηρεσία μας ακόμα καλύτερη.",
        "Τα σχόλιά σας έκαναν την ημέρα μας! Σας ευχαριστούμε για τις σκέψεις και τις προτάσεις σας.",
        "Στέλνουμε μια μεγάλη ευχαριστία για τα σχόλιά σας! Μας βοηθάτε να συνεχίσουμε να βελτιωνόμαστε και να αναπτυσσόμαστε.",
        "Σας ευχαριστούμε για τα σχόλιά σας και που είστε μέρος της κοινότητάς μας! Οι απόψεις σας διαμορφώνουν το μέλλον μας."
      ],
      "title": "Σας ευχαριστούμε! ❤️"
    },
    "tip": {
      "description": [
        "Εκτιμούμε πραγματικά την γενναιοδωρία σας! Σας ευχαριστούμε για το φιλοδώρημα και την υποστήριξή σας.",
        "Σας ευχαριστούμε για την καλοσύνη και την υποστήριξή σας! Το φιλοδώρημά σας σημαίνει τα πάντα για εμάς.",
        "Ουάου, σας ευχαριστούμε για την εκπληκτική γενναιοδωρία σας! Το φιλοδώρημά σας είναι βαθιά εκτιμημένο.",
        "Από όλους εμάς, μια εγκάρδια ευχαριστία για το φιλοδώρημά σας! Είμαστε ευγνώμονες για την υποστήριξή σας.",
        "Σας ευχαριστούμε που είστε τόσο γενναιόδωροι με το φιλοδώρημά σας! Η καλοσύνη σας δεν περνά απαρατήρητη.",
        "Το φιλοδώρημά σας έφτιαξε τη μέρα μας! Σας ευχαριστούμε για τη σκέψη και την υποστήριξή σας.",
        "Σας ευχαριστούμε πάρα πολύ για το φιλοδώρημά σας! Η γενναιοδωρία σας μας βοηθά να συνεχίσουμε να κάνουμε αυτό που αγαπάμε.",
        "Το φιλοδώρημά σας έφτιαξε τη μέρα μας! Σας ευχαριστούμε για την υποστήριξή σας και την καλοσύνη σας.",
        "Στέλνουμε μια μεγάλη ευχαριστία για το γενναιόδωρο φιλοδώρημά σας! Σημαίνει πολλά για εμάς.",
        "Σας ευχαριστούμε για το φιλοδώρημά σας και που είστε μέρος της κοινότητάς μας! Η υποστήριξή σας μας κρατάει σε λειτουργία."
      ],
      "emailsent": "Έχουμε στείλει μια απόδειξη στο email",
      "title": "Σας ευχαριστούμε! ❤️",
      "receipt": "Κάντε κλικ εδώ για να λάβετε μια απόδειξη της συναλλαγής",
      "email": "Email",
      "send": "Αποστολή",
      "download": "Ή <clickhere>κάντε κλικ εδώ</clickhere> για να την κατεβάσετε"
    }
  },
  "forbidden": {
    "title": "Συγγνώμη 💔",
    "description": "Δυστυχώς, η δυνατότητα φιλοδωρήματος έχει προσωρινά ανασταλεί για αυτόν τον εργαζόμενο. Αν θέλετε να αφήσετε σχόλια <clickhere>κάντε κλικ εδώ</clickhere>"
  },
  "pay": "Πληρωμή {{amount}}",
  "org": {
    "tipstovenue": "Αφήστε φιλοδωρήματα στο κατάστημα, τα φιλοδωρήματα θα μοιραστούν στους εργαζόμενους",
    "tipsquestion": "Σε ποιον θα θέλατε να αφήσετε φιλοδωρήματα;",
    "workers": "Εργαζόμενοι"
  }
}
